<p-tabs [value]="selectedTab">
  <p-tablist class="flex-shrink-0">
    <p-tab value="left" class="rounded-t-xl">
      {{ leftTabHeader }}
    </p-tab>
    <p-tab value="right" class="rounded-t-xl">
      {{ rightTabHeader }}
    </p-tab>
  </p-tablist>
  <p-tabpanel value="left">
    <app-card-with-header
      [usedWithTabs]="true"
      [hasHeader]="hasHeader"
      [hasFooter]="hasFooter"
    >
      <div header>
        <ng-content select="[leftTabheader]"></ng-content>
      </div>
      <div headerActions>
        <ng-content select="[leftTabHeaderActions]"></ng-content>
      </div>
      <ng-content select="[leftTabContent]"></ng-content>
      <div footer>
        <ng-content select="[leftTabFooter]"></ng-content>
      </div>
    </app-card-with-header>

  </p-tabpanel>
  <p-tabpanel value="right">
    <app-card-with-header
      [usedWithTabs]="true"
      [hasHeader]="hasHeader"
      [hasFooter]="hasFooter"
    >
      <div header>
        <ng-content select="[rightTabheader]"></ng-content>
      </div>
      <div headerActions>
        <ng-content select="[rightTabHeaderActions]"></ng-content>
      </div>
      <ng-content select="[rightTabContent]"></ng-content>
      <div footer>
        <ng-content select="[rightTabFooter]"></ng-content>
      </div>
    </app-card-with-header>
  </p-tabpanel>
</p-tabs>
